import { CompetitionCategorySelect } from '../../components/competition-category-select';
import { DistrictMultiSelect } from '~/pages/district/components/district-multi-select';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Table } from '~/components/Table/Table';
import { querySchema } from '../query-schema';
import { Grid } from '~/components/Grid/Grid';
import { Input } from '~/components/Input';

export function CompetitionListFilter() {
  const { register, setValue, values } = useFilterForm(querySchema.parse);

  return (
    <div
      style={{
        borderBottom: '2px solid var(--color-fg-secondary)',
        paddingBottom: 'var(--size-4)',
        marginBottom: 'var(--size-4)',
      }}
    >
      <Grid>
        <Grid.Item cols={{ sm: 6, md: 3 }}>
          <Table.Search placeholder="Sök på namn..." {...register('search')} aria-label="Sök" />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 3 }}>
          <DistrictMultiSelect
            {...register('districts')}
            onChange={values => setValue('districts', values.length ? values.join(',') : undefined)}
            value={values.districts?.length ? values.districts?.split(',').map(v => Number(v)) : []}
            placeholder="Alla distrikt"
          />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 3 }}>
          <Input.Select
            {...register('group')}
            aria-label="Tävlings relevans"
            options={[
              ['Alla tävlingar', 'ALL'],
              ['Aktuella tävlingar', 'CURRENT'],
              ['Genomförda tävlingar', 'COMPLETED'],
            ]}
          />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 3 }}>
          <CompetitionCategorySelect {...register('category')} />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 3 }}>
          <Input.Field
            onChange={event => setValue('from_end_date', event.target.value)}
            defaultValue={values.from_end_date}
            aria-label="Från datum"
            type="date"
          />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 3 }}>
          <Input.Field
            onChange={event => setValue('to_start_date', event.target.value)}
            defaultValue={values.to_start_date}
            aria-label="Till datum"
            type="date"
          />
        </Grid.Item>
      </Grid>
    </div>
  );
}
